<template>
  <div class="Herbal-medicine-detail">
    <!-- 公共头部 -->
    <!-- <vHeader></vHeader> -->
    <!-- 下半部分div -->
    <div class="contain">
      <el-row class="shareContent">
        <div class="domBox">
          <el-col :span="9">
            <el-carousel :interval="5000" arrow="always" :loop="true">
              <el-carousel-item  class="carousel-img-outer common-img-outer" v-if="drugPhotoUrl.length" v-for="(items, indexs) in drugPhotoUrl" :key="indexs">
                <el-image 
                  :src="$store.state.imgUrl+items" fit="cover">
                  <div slot="error" class="image-slot"> 
                    <img class="aa" src="../assets/img/suolue.jpg" alt/>  
                  </div>
                </el-image>
              </el-carousel-item>
              <el-carousel-item v-if="!drugPhotoUrl.length"  class="carousel-img-outer common-img-outer">
                <img src="../assets/img/suolue.jpg" alt/>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :span="15" class="jieshao">
            <div class="topInfo" >
              <div class="pinyin">{{ pinyinName }}</div>
              <div class="share">
                <el-button size="mini" icon="el-icon-share" class="shareJ" @click="shareF()">分享</el-button>
                <div>
                  <share :config="config1" style="display:inline-block" v-if="isShare"></share>
                </div>
                <div class="browse-count">浏览量：{{ atLlcs }}</div>
              </div> 
            </div>
            <div class="word">{{ atName }}</div> 
            <ul class="baseInfo">
              <li class="item bieming">
                <div>【别&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名】</div>
                <div>{{ drugAlias }}</div>
              </li>
              <li class="item bieming">
                <div>【药&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;性】</div>
                <div>{{ medicine }}</div>
              </li>
              <li class="item bieming">
                <div>【药&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;味】</div>
                <div>{{ pill }}</div>
              </li>
              <li class="item bieming">
                <div>【归&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经】</div>
                <div>{{ channelTropism }}</div>
              </li>
              <li class="item bieming">
                <div>【药用部位】</div>
                <div>{{ medicinalPart }}</div>
              </li>
            </ul>
          </el-col>
        </div> 
      </el-row>
      <!-- 下半部分 -->
      <el-row class="bottom-row" :gutter="20">
        <el-col :span="17" style="padding-left: 30px">
          <!-- <div class="title">
            <p class="iden"></p>药用部位描述
          </div>
          <div class="content">{{ medicinalPartDescribe }}</div> -->
          <div class="title">
            <p class="iden"></p>储藏方式
          </div>
          <div class="content">{{ atZcfs }}</div>
          <!-- <div class="title">
            <p class="iden"></p>药材性状描述
          </div>
          <div class="content">{{ medicinalShapeDescribe }}</div> -->
          <div class="title">
            <p class="iden"></p>药品产地
          </div>
          <div class="content">{{ atSpcd }}</div>
          <!-- <div class="title">
            <p class="iden"></p>植物形态特征
          </div>
          <div class="content">{{ plantShapeDescribe }}</div> -->
          <!-- <div class="title">
            <p class="iden"></p>采收加工
          </div>
          <div class="content">{{ collectionProcessing }}</div> -->
          <div class="title">
            <p class="iden"></p>药品用法用量
          </div>
          <div class="content">{{ drugUsageAndDosage }}</div>
          <div class="title">
            <p class="iden"></p>炮制方法
          </div>
          <div class="content">{{ preparationMethodDescribe }}</div>
          <div class="title">
            <p class="iden"></p>药品功效与作用
          </div>
          <div class="content">{{ efficacyDrugsDescribe }}</div>
            <div class="title">
            <p class="iden"></p>相反药物
          </div>
          <div class="content">{{ reverseDrugs }}</div>

          <div class="title">
            <p class="iden"></p>药品主治
          </div>
          <div class="content">{{ drugIndications }}</div>
          <div class="title">
            <p class="iden"></p>药品使用禁忌
          </div>
          <div class="content">{{ ypsyjj }}</div>
        </el-col>
        <el-col :span="7">
          <div class="common-img-outer setPositon listdetail-adver-outer-img Box" v-for="(item, index) in zhongcaoyaoAdverList" :key="index">
            <a :href="item.urlLink">
              <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
              <span class="adver-words-tip" v-if="item.urlImage">{{
                adverWordsTip
              }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "HerbalMedicineDetail",
  data () {
    return {
      id: "",
      drugPhotoUrl: [],
      pinyinName: "",
      atName: "",
      drugAlias: "",
      medicine: "",
      pill: "",
      channelTropism: "",
      medicinalPart: "",
      atLlcs: "",
      medicinalPartDescribe: "",
      atZcfs:"",
      medicinalShapeDescribe: "",
      atSpcd: "",
      plantShapeDescribe: "",
      collectionProcessing: "",
      drugUsageAndDosage: "",
      preparationMethodDescribe: "",
      efficacyDrugsDescribe: "",
      drugIndications: "",
      ypsyjj: "",
      reverseDrugs: ""
    };
  },
  methods: {
    getDetail (id) {
      let that = this;
      let url = "/ypgl/getYpglByDetail";
      let parmas = {
        id: id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            if (arr.drugPhotoUrl) {
              //   that.drugPhotoUrl = arr.drugPhotoUrl.split(",");
              let urls = [];
              if (arr.drugPhotoUrl) {
                let str = arr.drugPhotoUrl;
                if (str[str.length - 1] === ',') {
                    str = str.slice(0, str.length - 1);
                }
                urls = str.split(",");
              } else {
                urls = [];
              }
              that.drugPhotoUrl = urls;
            }
              that.pinyinName = arr.pinyinName;
              that.atName = arr.atName;
              that.drugAlias = arr.drugAlias;
              that.medicine = arr.medicine;
              that.pill = arr.pill;
              that.channelTropism = arr.channelTropism;
              that.medicinalPart = arr.medicinalPart;
              that.efficacyDrugsDescribe = arr.efficacyDrugsDescribe;
              that.atLlcs = arr.atLlcs;
              that.medicinalPartDescribe = arr.medicinalPartDescribe;
              that.atZcfs=arr.atZcfs;
              that.medicinalShapeDescribe = arr.medicinalShapeDescribe;
              that.atSpcd = arr.atSpcd;
              that.plantShapeDescribe = arr.plantShapeDescribe;
              that.collectionProcessing = arr.collectionProcessing;
              that.drugUsageAndDosage = arr.drugUsageAndDosage;
              that.preparationMethodDescribe = arr.preparationMethodDescribe;
              that.drugIndications = arr.drugIndications;
              that.ypsyjj = arr.ypsyjj;
              that.reverseDrugs = arr.reverseDrugs;

          } else {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.$message.error("网络错误！");
        });
    }
  },
  created () {
    let that = this;
    that.getPositionAdver(4, 3);
    if (!!that.$route.query.id) {
      that.getDetail(that.$route.query.id);
    }
  }
};
</script>
<style>
/* 设置el-tooltip最大宽度 */
.item-top-intro {
  max-width: 200px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carousel-img-outer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.Herbal-medicine-detail {
  /*padding-top: 44px;*/
}
.Herbal-medicine-detail .el-carousel__container .outer-img {
  width: 400px;
  height: 400px !important;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.adv-wrap {
  padding-top: 30px;
}
.shareContent {
  padding: 20px;
  background-color: #f9f9f9;
}
.adv-div {
  /* width: 310px;
    height: 190px; */
  /* background-color: #d3d3d3; */
  /* margin-top: 20px; */
  cursor: pointer;
  margin-top: 20px;
}
.iden {
  width: 3px;
  height: 19px;
  margin-right: 7px;
  background-color: #f64420;
}
.bottom-row {
  margin-top: 30px;
}
.bottom-row .title {
  font-size: 16px;
  display: flex;
  line-height: 24px;
  /*color: #f64420;*/
}
.bottom-row .content {
  font-size: 16px;
  margin-left: 10px;
  line-height: 36px;
  color: #666666;
  margin-bottom: 20px;
}
.jieshao {
  /*height: 300px;*/
}
.last-div {
  padding-top: 20px;
}
.browse-count { 
  font-size: 14px;
  color: #999999;
}
.shareJ {
  background-color: #f64420;
  color: white;
  text-align: center;
  margin-right: 5px;
  font-size: 18px;
}
.yaoxing {
  width: 100%;
  height: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
.yaoxing .tit{
  float: left;
}
.yaoxing .tit-item{
  float: left;
}
.yaoxing .tit-item /deep/.el-button{
  width: 160px!important;
  color: #666;
  overflow: hidden;
  height: 20px;
  line-height: 23px;
  text-align: left;
  padding: 0!important;
  background-color:transparent!important;
  border: none;
  overflow: hidden; /* 确保超出容器的文本被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 使用省略号表示文本超出 */
}
/deep/ .el-divider {
  margin: 10px 0 20px 0;
}
.Box {
  border-radius: 3px;
}
.bieming {
  font-size: 14px;
  line-height: 24px;
  color: #666;
}
.word {
  font-size: 26px;
  color: #f64420;
}
.jieshao {
  padding: 20px; 
}
.pinyin {
  font-size: 16px;
  color: #999999;
}
.domBox{
  background: #fff;
  border-radius: 4px;
  display: flex;
  overflow: hidden;
}
.topInfo{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.share{
  display: flex;
  align-items: center;
}
.item {
  display: flex;
}
.item + .item{
  margin-top: 10px;
}
.baseInfo{
  margin-top:10px;
}
.el-carousel{
  height: 100%;
  border-radius:4px;
}
>>>.el-carousel__container{
  height: 100%;
  min-height: 300px;
}
.el-image{
  width:100%;
  height: 100%;
}
>>>.image-slot{
  width:100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/HerbalMedicineDetail.vue